import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Fuse from "fuse.js";
import sortTasks from "../../helpers/sort";
import Task from "./taskCard/Task";
import GradientButton from "../input/GradientButton";

const List = ({ tasks, listId, searchTerm, userHasTasks, compact = false, onOpenTaskHelper }) => {
  const { filters, sortOrder, mindset } = useSelector((state) => state.user);
  const [forceSort, setForceSort] = useState(true); //Used to trigger re-sort if something changes about a task that may affect it's order

  //This memo asks the list to re-sort the tasks, which allows tasks to move up the sort order in realtime as their urgency changes
  const displayTasks = useMemo(() => {
    if (tasks) {
      let tasksToSort;
      //If there is no search term and no filters, include all tasks
      if (
        !searchTerm &&
        (!filters ||
          !filters.labels ||
          !Object.values(filters.labels).some(
            (filterStatuses) =>
              filterStatuses.include || filterStatuses.exclude,
          ))
      ) {
        tasksToSort = tasks;
      } else {
        let searchFilteredTasks = tasks;
        if (searchTerm !== "") {
          const fuse = new Fuse(tasks, {
            keys: ["name"],
            distance: 100,
            threshold: 0.4,
          });
          searchFilteredTasks = fuse
            .search(searchTerm)
            .map((result) => result.item);
        }

        tasksToSort = searchFilteredTasks.filter((task) => {
          // If the task has a label has a label in the selected filters, include it
          // But if the task has a label which is not in the selected filters, exclude it
          let hasExcludedLabel = Object.entries(filters.labels).some(
            ([labelName, filterStatuses]) => {
              return filterStatuses.exclude && task.labels?.includes(labelName);
            },
          );

          // If the task has excluded label, we don't need to check for included labels
          if (hasExcludedLabel) return false;

          let hasIncludedLabel = Object.entries(filters.labels).some(
            ([labelName, filterStatuses]) => {
              return filterStatuses.include && task.labels?.includes(labelName);
            },
          );

          // If no label is set to be included, then it means we show all tasks that do not have an excluded label
          // Otherwise, we show only tasks that have at least one included label
          return (
            Object.values(filters.labels).every(
              (filterStatus) => !filterStatus.include,
            ) || hasIncludedLabel
          );
        });
      }

      const sortedTasks = sortTasks({
        tasksToSort,
        sortOrder,
        mindset,
      });

      setForceSort(false);
      return sortedTasks;
    }
  }, [forceSort, tasks, filters, searchTerm, sortOrder, mindset]);

  return (
    <div className="task-list__list">
      {userHasTasks ? (
        displayTasks?.map((item) => (
          <Task
            item={item}
            key={item.taskId}
            compact={compact}
            forceListToResort={() => {
              setForceSort(true);
            }}
          />
        ))
      ) : (
        <GradientButton
          text="Create your first task"
          onClick={onOpenTaskHelper}
          sx={{ alignSelf: "center" }}
        />
      )}
    </div>
  );
};

export default List;
